<script setup lang="ts">
import InfoIcon from '@/assets/icons/InfoIcon.vue';
</script>

<template>
  <div
    class="flex min-h-8 w-full min-w-0 items-center gap-sm rounded-sm bg-ocean-100 px-sm py-xs text-ocean-600"
    role="status"
  >
    <InfoIcon class="size-icon-xs shrink-0" aria-hidden="true" />
    <p class="min-w-0 text-footer">
      <slot />
    </p>
  </div>
</template>
